import { setProps } from '../props'
import fetch from '../Services/fetch'

export default (props) => async (dispatch) => {

  setProps(props)

  dispatch(fetch())

}